export enum PackingBOMStatusEnum {
    OPEN = 'OPEN',
    GRN = 'GRN',
    BULK = 'BULK',
    PO = 'PO',
}